import { cn } from '@/lib/cn';
import {
  PROJECT_STATUSES,
  PROJECT_STATUS_LABEL,
  type ProjectStatus,
} from '@/lib/project-types';

/**
 * Compact project-status dropdown. When rendered inside a react-router `<Link>`
 * (the project cards), pass `insideLink` so a click sets the status without
 * navigating into the board.
 */
export function ProjectStatusSelect({
  value,
  onChange,
  disabled,
  insideLink,
  className,
}: {
  value: string;
  onChange: (status: ProjectStatus) => void;
  disabled?: boolean;
  insideLink?: boolean;
  className?: string;
}) {
  return (
    <select
      value={value}
      disabled={disabled}
      aria-label="Project status"
      onClick={
        insideLink
          ? (e) => {
              e.preventDefault();
              e.stopPropagation();
            }
          : undefined
      }
      onChange={(e) => {
        if (insideLink) {
          e.stopPropagation();
        }
        onChange(e.target.value as ProjectStatus);
      }}
      className={cn(
        'h-7 rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] px-2 text-xs font-medium text-[var(--color-foreground)] focus:border-[var(--color-ring)] focus:outline-none disabled:opacity-60',
        className,
      )}
    >
      {PROJECT_STATUSES.map((status) => (
        <option key={status} value={status}>
          {PROJECT_STATUS_LABEL[status]}
        </option>
      ))}
    </select>
  );
}
